/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as c from "react";
import { Button as f } from "@progress/kendo-react-buttons";
import { EditorToolsSettings as u } from "../config/toolsSettings.mjs";
import { isAligned as v, alignBlocks as T } from "@progress/kendo-editor-common";
import { onDownPreventDefault as h } from "./utils.mjs";
import { registerForLocalization as z, provideLocalizationService as A } from "@progress/kendo-react-intl";
import { messages as L } from "../messages/index.mjs";
const { alignRemove: l } = u, C = (t) => {
  const n = class extends c.Component {
    render() {
      const { view: o, render: r, ...m } = this.props, i = o && o.state, e = !!i && v(i, t.actions), p = e ? l.actions : t.actions, d = e ? l.commandName : t.commandName, g = A(this), a = t.messages.title, s = /* @__PURE__ */ c.createElement(
        f,
        {
          onClick: () => o && T(p, d)(o.state, o.dispatch),
          selected: e,
          togglable: !0,
          ...h,
          title: g.toLanguageString(a, L[a]),
          ...t.props,
          ...m
        }
      );
      return r ? r.call(void 0, s, { view: o }) : s;
    }
  };
  return z(n), n;
};
export {
  C as createAlignTool
};
